export const SENTRY_CONSTANTS = {
  OWNERSHIP_TEAM: 'ovatient-metrohealth-web',
};
